import { createSelector } from 'reselect';
import { flatMap, get, map, mapValues } from 'lodash/fp';

const annotatePlayers = map(p => ({
  ...p,
  teamAbbr: p.isHome ? p.homeAbbr : p.awayAbbr
}));

function getPlayers(group = {}) {
  const players = flatMap(annotatePlayers, mapValues('players', get('positions', group)));

  return players
    .filter(({ isLocked }) => !isLocked)
    .map(p => ({ ...p, exposure: Math.round((p.entryCount / group.totalEntries) * 100) }));
}

const playerSwapMyPlayersSelector = createSelector(get('playerSwap.selectedSlate'), getPlayers);

export default playerSwapMyPlayersSelector;
